import type { FaireProductEntity } from "../../entity_types/product";

export const p_a8g27yvxyn: FaireProductEntity = {
  token: "p_a8g27yvxyn",
  type: "product",
  name: "7 Piece 18K Gold Plated Earring Set",
  brandToken: "b_3u7f7kz1",
  brandName: "Golden NYC Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/6ea43949f98c06cb470ff8ff15ccde0e529341e553ef41c6e427906ade28fcf9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f4ba6ae908af5c717f4e7eb02484f4a70ad1f03ee4f416d2d53417899c4beb2e.jpeg",
    "https://cdn.faire.com/fastly/ac0b551f747e4077642241d248dc367f547672f6b628634af6d06385289b11ee.jpeg",
    "https://cdn.faire.com/fastly/cfde6fde8cedbfc7343493302254cf016fe175c30760c3c34f0bef5e65913a7c.jpeg",
    "https://cdn.faire.com/fastly/a3c446cd8e66e4fdd45d3fcbd64960512db0be4c7b9b06d54bb5e838976c15c3.jpeg",
    "https://cdn.faire.com/fastly/4beae925850823f12cab8af4c69c97008cf669d9eeb2343637c53602154949ef.jpeg",
  ],
  priceDollars: 6.93,
  description:
    "Our 7 Piece 18K Gold Plated Earring Set by Golden NYC Jewelry is an investment in essential style. This hypoallergenic set ensures a comfortable fit, offering you a wide range of options to play with your style. Designed at our New York City headquarters, this set is a reflection of the latest trends, making it easy to update your wardrobe. Enjoy a new arrival every Sunday, all from the city that never sleeps. Fashion should be fun, and with this set, it is.",
  tags: [],
  msrpDollars: 48.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:30.277Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
